import { useMemo } from "react";

import { REVISAO_LEGEND } from "../../resolver-conflito-local.constants";
import { buildRevisaoData, obraLabel } from "../../resolver-conflito-local.utils";
import type { RevisaoStepProps, RevisaoStepViewModel } from "./types-revisao-step";

/** Etapa Revisão: a troca que será feita, o Gantt dos dois locais e a justificativa. */
export function useRevisaoStep({
  local,
  alocacao,
  substituto,
  data,
  periodo,
  today,
  disabled,
  justificativa,
}: RevisaoStepProps): RevisaoStepViewModel {
  const gantt = useMemo(
    () =>
      buildRevisaoData({
        locais: data?.locais ?? [],
        ignorados: data?.conflitosIgnorados ?? [],
        origem: local,
        alocacao,
        substituto,
      }),
    [data, local, alocacao, substituto],
  );

  return {
    localNome: local.nome,
    substitutoNome: substituto.nome,
    obraRotulo: `Obra ${obraLabel(alocacao)}`,
    legenda: REVISAO_LEGEND,
    gantt,
    alocacao,
    periodo,
    today,
    disabled,
    justificativa,
  };
}
